export const EVENT_OPTIONS = [
  { label: "All Events", value: "" },
  { label: "Login", value: "login" },
  { label: "Logout", value: "logout" },
  { label: "Signup", value: "signup" },
  { label: "User Deactivated", value: "user_deactivated" }
];

export const SOURCE_OPTIONS = [
  { label: "All Sources", value: "" },
  { label: "Platform", value: "platform" },
  { label: "Admin Panel", value: "admin_panel" }
];
